<template>
  <div class="rating-history">
    <div class="t-lk-container">
      <lk-breadcrumbs :breadcrumbs="breadcrumbs" />
      <lk-table :config="config" :data="ratingHistoryList" :pagination="paginationData">
        <template #filter>
          <lk-filter-cmp
            v-if="filters"
            class="rating-history__item-filter"
            :filter="filters"
            :obj-undefined="{ currentPage: undefined }"
            :name-btn="$root.staticText.lk.leadsFilterBtn"
            :is-date="true"
            :is-date-left="false"
          >
          </lk-filter-cmp>
        </template>
        <template #description="{ value }">
          <Tooltip :text="value">
            <p class="rating-history__description-field rating-history__description-field--success">{{ value }}</p>
          </Tooltip>
        </template>
        <template #vendor="{ value }">
          <p class="rating-history__vendor-field">{{ getVendorName(value) }}</p>
        </template>
        <template #user="{ value }">
          {{ getUserName(value) }}
        </template>
      </lk-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LkBreadcrumbs from '@components/lk/lk-breadcrumbs/lk-breadcrumbs.vue'
import LkTable from '@components/lk/lk-table/lk-table.vue'
import { LEADS_TABLE_CONFIG } from '@pages/lk/leads/config/leads.table.config'
import onScrollAnimate from '@assets/js/scrollAnimate'
import lkFieldFilter from '@components/lk/lk-filter/lk-filter.vue'
import Tooltip from '@shared/ui/lk/Tooltip.vue'

export default {
  name: 'lk-rating-history',
  components: {
    'lk-filter-cmp': lkFieldFilter,
    'lk-breadcrumbs': LkBreadcrumbs,
    'lk-table': LkTable,
    Tooltip,
  },
  data() {
    return {
      breadcrumbs: [
        { link: 'leads', text: 'Лиды' },
        { link: '', text: 'История начисления' },
      ],
      config: LEADS_TABLE_CONFIG,
    }
  },
  async created() {
    await this.loadReputationHistory()
  },
  computed: {
    ...mapGetters('ratingHistory', {
      ratingHistoryList: 'list',
      filters: 'filters',
      paginationData: 'pagination',
    }),
  },
  methods: {
    ...mapActions('ratingHistory', ['loadRatingHistory']),
    async loadReputationHistory(query) {
      try {
        await this.loadRatingHistory(query ?? this.$route.query)
      } catch (e) {
        console.log(e)
      }
    },
    getUserName(user) {
      return [user.surname, user.name].join(' ')
    },
    getVendorName(vendor) {
      return vendor?.name ?? ''
    },
  },
  async beforeRouteUpdate(to, _, next) {
    await this.loadRatingHistory(to.query)
    this.$root.setDataAnimateFalse('.t-lk-container ')
    setTimeout(onScrollAnimate, 500)
    next()
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.rating-history
  &__description-field
    width: 100%
    font-weight: 600

    &--success
      color: $dark-shades-black

  &__vendor-field
    font-weight: 600
</style>



// WEBPACK FOOTER //
// src/templates/pages/lk/rating-history/index.vue